import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{page-title \"Informations légales\"}}\n\n<LegalInfo::TermsOfUse />",{ moduleName: "parog-web/templates/view-terms-of-use.hbs" })